<template>

  <div class="videoMain" ref="playWndBox" id="videoMain">
    <div id="playWnd" class="playWnd" ref="playWnd">

    </div>

  </div>

</template>
<script>
import { decrypt } from '@/utils/jsencrypt'
import axios from 'axios';
// import {getHikvision,getHikvisionList } from '@/api/work/big_view'
export default {
  data() {
    return {
      visionList:[],
      token:localStorage.getItem('token'),
      preTime: null,
      ifInOut: 5,//是否第一次进入直播轮巡
      inter: null,
      camerIndex: 0,
      timer: null,
      showLive: true,
      // 视频盒子的高度
      playWndHeight: "",
      // 视频盒子的宽度
      playWndWidth: "",
      oWebControl: null,
      initCount: 0,
      pubKey: "",
      EncryptKey: '',
      // cameraIndexCode: "",  // 这里面是监控点编号
      objData: {
        //海康初始化数据
        appkey: "28683477",
        ip: "103.56.152.126",
        secret: "SzOvm8jV1GjNKRVwbYaQ",
        port: 9443,
        playMode: 0, // 0 预览 1回放
        layout: "1x1", //页面展示的模块数【16】
      },
    }
  },
  props: {
    hikvisionType:{
      type:String,
      default:''
    },
  },
  watch:{ 
       hikvisionType:{
      handler(newValue, oldValue) {
        // newValue==null?this.hikvisionType='hikvision':this.hikvisionType=newValue
        this.hikvisionType=newValue

        // this.getVision()
        console.log('hikvisionType changed*********:', newValue);
      },
      deep: true,
      immediate:false,
    },
  },
   created() {
   axios({
          url: this.$root.BASE_URL + `/system/dict/data/hikvision-list`,
          method: "get",
          headers: {
            authorization: this.token,
          },
        }).then((res) => {
          console.log(res)
  if(res.data.code==200){
    console.log(res.data,'系列数----------')
    res.data.data.forEach(item=>{
      let obj={}
      obj.authUuid=item.hikvisionType
      let vision=item.hikvisionConfigMap
      
        obj.appkey=decrypt(vision.hikvision_appkey)
        // let secret=decrypt(vision.hikvision_secret)
        // obj.secret=that.setEncrypt(secret)
        
        obj.secret=decrypt(vision.hikvision_secret)
        obj.ip=decrypt(vision.hikvision_ip)
        obj.port=Number(decrypt(vision.hikvision_port))
        obj.encryptedFields= ""
        this.visionList.push(obj)
      console.log(obj.secret,'vision.hikvision_secret')
    })
   
    console.log(this.visionList,'系列数OMG!!!!!!!!!----------')
  }
        });

},
  Updated() {
    // console.log('Updated....')

  },
  mounted() {
    // 首次加载时的到父容器的高度
    this.playWndHeight = this.$refs.playWnd.offsetHeight
    // // 首次加载时的到父容器的宽度
    this.playWndWidth = this.$refs.playWnd.offsetWidth


    this.initPlugin()
    //  this.initAll()
    // 监听浏览器的变化
    this.monitoringWindow();


    // this.play()
  },
  beforeDestroy() {
    clearInterval(this.preTime)
    // this.showLive=false
    // console.log('视频销毁.....123')
    if (this.oWebControl != null) {
      // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
      this.oWebControl.JS_HideWnd();
      // 销毁当前播放的视频
      // this.oWebControl.JS_RequestInterface({ funcName: "destroyWnd" });
      // 断开与插件服务连接
      // this.oWebControl.JS_Disconnect();
    }
  },
  methods: {
    initAll() {
      let that = this
      console.log(this.oWebControl.JS_RequestInterface({
        funcName: "stopAllPreview"
      }), 123)
      this.oWebControl.JS_StartService("window", {         // WebControl实例创建成功后需要启动服务
        dllPath: "./VideoPluginConnect.dll"         // 值"./VideoPluginConnect.dll"写死 
      }).then(function () {                           // 启动插件服务成功
        this.oWebControl.JS_SetWindowControlCallback({   // 设置消息回调
          cbIntegrationCallBack: that.cbIntegrationCallBack
        });

        this.oWebControl.JS_CreateWnd("playWnd", this.playWndWidth, this.playWndHeight).then(function () { //JS_CreateWnd创建视频播放窗口，宽高可设定
          // console.log('cbConnectSuccess1111........')
          that.init();  // 创建播放实例成功后初始化
        });
      }, function () { // 启动插件服务失败
      });
    },
    // 创建播放实例
    initPlugin() {
      // console.log('创建播放实例.......',)
      // console.log(new WebControl())
      let that = this

      this.oWebControl = new WebControl({
        szPluginContainer: "playWnd",                       // 指定容器id
        iServicePortStart: 15900,                           // 指定起止端口号，建议使用该值
        iServicePortEnd: 15900,
        szClassId: "23BF3B0A-2C56-4D97-9C03-0CB103AA8F11",   // 用于IE10使用ActiveX的clsid
        cbConnectSuccess: function () {

          // console.log('cbConnectSuccess........')                  // 创建WebControl实例成功											
          that.oWebControl.JS_StartService("window", {         // WebControl实例创建成功后需要启动服务
            dllPath: "./VideoPluginConnect.dll"         // 值"./VideoPluginConnect.dll"写死 
          }).then(function () {                           // 启动插件服务成功
            that.oWebControl.JS_SetWindowControlCallback({   // 设置消息回调
              cbIntegrationCallBack: that.cbIntegrationCallBack
            });

            that.oWebControl.JS_CreateWnd("playWnd", that.playWndWidth, that.playWndHeight).then(function () { //JS_CreateWnd创建视频播放窗口，宽高可设定
              // console.log('cbConnectSuccess1111........')
              that.init();  // 创建播放实例成功后初始化
            });
          }, function () { // 启动插件服务失败
          });
        },
        cbConnectError: function () { // 创建WebControl实例失败
          that.oWebControl = null;
          // console.log('插件未启动，正在尝试启动，请稍候...')
          $("#playWnd").html("插件未启动，正在尝试启动，请稍候...");
          WebControl.JS_WakeUp("VideoWebPlugin://"); // 程序未启动时执行error函数，采用wakeup来启动程序
          that.initCount++;
          if (that.initCount < 3) {
            setTimeout(function () {
              that.initPlugin();
            }, 3000)
          } else {
            // that.downLoad()
            // console.log('插件启动失败，请检查插件是否安装')
            let innerHTML = "<div >插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！</div>";
            $("#playWnd").html("插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！")
            $("#downLoad").click(() => {

              that.downLoad()
            })
          }
        },
        cbConnectClose: function (bNormalClose) {
          // 异常断开：bNormalClose = false
          // JS_Disconnect正常断开：bNormalClose = true	
          // console.log("cbConnectClose");
          that.oWebControl = null;
          // console.log('插件未启动，正在尝试启动，请稍候...')
          // $("#playWnd").html("插件断开");
          WebControl.JS_WakeUp("VideoWebPlugin://");
          that.initCount++;
          if (that.initCount < 3) {
            setTimeout(function () {
              that.initPlugin();
            }, 3000)
          } else {
            // that.downLoad()
            // console.log('插件启动失败，请检查插件是否安装！')
            let innerHTML = "<div >插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！</div>";
            $("#playWnd").html("插件启动失败，点击 <a id='downLoad' style='color:blue' >下载<a> 安装！")
            $("#downLoad").click(() => {
              that.downLoad()

            })
          }
        }
      });

    },
    // 初始化
    init() {
      // console.log('初始化......',)
      let that = this;
      that.getPubKey(() => {
        let appkey = that.objData.appkey;                   //综合安防管理平台提供的appkey，必填
        let secret = that.setEncrypt(that.objData.secret); //综合安防管理平台提供的secret，必填
        let ip = that.objData.ip;                           //综合安防管理平台IP地址，必填
        let playMode = that.objData.playMode;               //初始播放模式：0-预览，1-回放
        let port = that.objData.port;                       //综合安防管理平台端口，若启用HTTPS协议，默认443
        let snapDir = "D:\\SnapDir";                        //抓图存储路径
        let videoDir = "D:\\VideoDir";                       //紧急录像或录像剪辑存储路径
        let layout = that.objData.layout;                   //playMode指定模式的布局
        let enableHTTPS = 1;                                //是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
        let encryptedFields = "secret";                     //加密字段，默认加密领域为secret
        let showToolbar = 1;                                //是否显示工具栏，0-不显示，非0-显示
        let showSmart = 0;                                  //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        let reconnectTimes = 3  //重连设置0-无限重连 >0-重连次数 <0-不重连，
        let reconnectDuration = 10 //重连间隔时间

        let buttonIDs = "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769"; //自定义工具条按钮
        // var toolBarButtonIDs = "2049,2304" // 工具栏上自定义按钮
        that.oWebControl
          .JS_RequestInterface({
            funcName: "init",
            argument: JSON.stringify({
              // appkey: appkey,                 //API网关提供的appkey
              // secret: secret,                 //API网关提供的secret
              // ip: ip,                         //API网关IP地址
              playMode: playMode,             //播放模式（决定显示预览还是回放界面）
              // port: port,                     //端口
              snapDir: snapDir,               //抓图存储路径
              videoDir: videoDir,             //紧急录像或录像剪辑存储路径
              layout: layout,                 //布局
              enableHTTPS: enableHTTPS,       //是否启用HTTPS协议
              encryptedFields: encryptedFields, //加密字段
              showToolbar: showToolbar,       //是否显示工具栏
              showSmart: showSmart,           //是否显示智能信息
              buttonIDs,                      //自定义工具条按钮
              reconnectTimes,
              reconnectDuration
            }),
          })
          .then(function () {
            // console.log('初始化成功')
            that.oWebControl.JS_Resize(that.playWndWidth, that.playWndHeight);
            that.oWebControl.JS_RequestInterface({
              funcName:'setAuthInfo',
              argument:{
                list:that.visionList
              }
            }).then(res=>{
              console.log('成功setAuthInfo',that.visionList)
            }).catch(err=>{
              console.log('失败setAuthInfo')
            })

          }).catch((err) => {
            // console.log(err,'初始化err....')
          })
      });
    },
    setNumber(number, list) {
      // console.log('色值化成功',number)
      let that = this
      this.oWebControl
        .JS_RequestInterface({
          funcName: "setLayout",
          argument: JSON.stringify({
            layout: number
          })
        })
        .then(function () {
          // console.log('色值化成功')
          if (list.length > 0) {
            that.playAll(list)
          }


        }).catch((err) => {
          // console.log(err,'色值化err....')
        })
    },
    async downLoad() {
      // console.log('下载........')
      let response = await fetch('http://cctv.hbrytech.cn:2123/prod-api/profile/upload/plug/VideoWebPlugin.exe');
      let url = 'http://cctv.hbrytech.cn:2123/prod-api/profile/upload/plug/VideoWebPlugin.exe'
      const a = document.createElement('a')
      a.href = url
      a.download = 'VideoWebPlugin.exe' // 下载后文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click() // 点击下载
      document.body.removeChild(a) // 下载完成移除元素
    },
    play(cameraIndexCode) {
      
       let authUuid
      if(this.hikvisionType==null)
    {
      authUuid='hikvision'
    }else{
      authUuid=this.hikvisionType
    }
    console.log('播放一下',cameraIndexCode,'authUuid',authUuid)
      var streamMode = 0;                                     //主子码流标识：0-主码流，1-子码流
      var transMode = 1;                                      //传输协议：0-UDP，1-TCP
      var gpuMode = 0;                                        //是否启用GPU硬解，0-不启用，1-启用
      var wndId = -1;                                         //播放窗口序号（在2x2以上布局下可指定播放窗口）
      let that = this
      this.oWebControl.JS_RequestInterface({
        funcName: "startPreview",
        argument: JSON.stringify({
          cameraIndexCode: cameraIndexCode,                //监控点编号
          streamMode: streamMode,                         //主子码流标识
          transMode: transMode,                           //传输协议
          gpuMode: gpuMode,                               //是否开启GPU硬解
          wndId: wndId ,                                    //可指定播放窗口
          authUuid:authUuid
        })
      }).then(res=>{
        console.log('bofangchengg ')
      })
    },
    playAll(data) {
      // console.log('播放QUANBU',data)
      var streamMode = 0;                                     //主子码流标识：0-主码流，1-子码流
      var transMode = 1;                                      //传输协议：0-UDP，1-TCP
      var gpuMode = 0;                                        //是否启用GPU硬解，0-不启用，1-启用
      var wndId = -1;                                         //播放窗口序号（在2x2以上布局下可指定播放窗口）
      let that = this
      let list = []
       let authUuid
      if(this.hikvisionType==null)
    {
      authUuid='hikvision'
    }else{
      authUuid=this.hikvisionType
    }
      data.forEach((item, index) => {
        let obj = {
          cameraIndexCode: item,                //监控点编号
          streamMode: streamMode,                         //主子码流标识
          transMode: transMode,                           //传输协议
          gpuMode: gpuMode,                               //是否开启GPU硬解
          wndId: index + 1 ,                                   //可指定播放窗口
          authUuid:authUuid
        }
        list.push(obj)
      })
      // console.log(list,'list')
      this.oWebControl.JS_RequestInterface({
        funcName: "startMultiPreviewByCameraIndexCode",
        argument: { list }
      }).catch(er => {
        // console.log('失败',er)
      })
    },
    // 停止所有视频预览
    stopAllPreview() {
      this.oWebControl.JS_RequestInterface({
        funcName: "stopAllPreview"
      });
    },
    Preview(list) {
      var WndNum = 1
      let that = this
      this.oWebControl.JS_RequestInterface({
        funcName: "getLayout"
      }).then(function (oData) {
        //分析窗口数
        var Data = JSON.stringify(oData.responseMsg.data);
        Data = Data.replace(/\\n/g, "");
        Data = Data.replace(/\\/g, "");
        Data = Data.replace(/\"{/g, "{");
        Data = Data.replace(/}\"/g, "}");
        WndNum = JSON.parse(Data).wndNum;
      })

      that.inter = setInterval(() => {
        that.lunxun(WndNum, list)
      }, 1000 * 10);



    },
    lunxun(WndNum, list) {
      for (let i = 0; i < WndNum; i++) {
        let cameraIndexCode
        if (this.camerIndex < list.length) {
          cameraIndexCode = list[this.camerIndex]
        } else {
          this.camerIndex = 0
          cameraIndexCode = list[this.camerIndex]
        }

        var previewParam = {
          argument: JSON.stringify({
            cameraIndexCode: cameraIndexCode,                //监控点编号
            streamMode: 0,                         //主子码流标识
            transMode: 1,                           //传输协议
            gpuMode: 0,                               //是否开启GPU硬解
            wndId: i + 1                                     //可指定播放窗口
          }),
          funcName: "startPreview"
        };
        this.camerIndex += 1
        // console.log(previewParam,'-----previewParam-----')
        this.prewPlay(previewParam)
      }
    },
    prewPlay(previewParam) {
      let that = this
      this.oWebControl.JS_RequestInterface(previewParam).then(res => {
        // console.log(res,'正确...')
      }).catch(err => {
        // console.log(err,'戳无...')
      })
    },
    clear() {
      this.ifInOut = 0
      clearInterval(this.inter)
      this.stopAllPreview()
    },
    // bianli
    getList(WndNum) {
      for (let i = 0; i < WndNum; i++) {
        var cameraIdx = cameraIndexArray[i % arraySize];
        var previewParam = JSON.stringify({
          "argument": {
            "authUuid": "",
            "cameraIndexCode": cameraIdx,
            "ezvizDirect": 0,
            "gpuMode": 0,
            "streamMode": 0,
            "transMode": 1,
            "wndId": i + 1,
            "cascade": 1
          },
          "funcName": "startPreview"
        });
      }
    },
    /*
        // 单路播放轮巡函数
         SingleTourPreview(cameraIndexArray) {
          console.log('------------SingleTourPreview----------')
            // // 解析轮巡的监控点编号
            // var param = $("#TourPreviewCamIdx").val();
            // //param = param.replace(/(\s*)/g, "");
            // var cameraIndexArray = new Array();
            // cameraIndexArray = param.split(",");
            var arraySize = cameraIndexArray.length;
            let that=this
            // 获取当前窗口个数
            var WndNum = 1;
            this.oWebControl.JS_RequestInterface({
                funcName: "getLayout"
            }).then(function (oData) {
                //分析窗口数
                var Data = JSON.stringify(oData.responseMsg.data);
                Data = Data.replace(/\\n/g, "");
                Data = Data.replace(/\\/g, "");
                Data = Data.replace(/\"{/g, "{");
                Data = Data.replace(/}\"/g, "}");
                WndNum = JSON.parse(Data).wndNum;
                
                for (let i = 0; i < WndNum; i++)
                {
                    var cameraIdx = cameraIndexArray[i % arraySize];
                    var previewParam = JSON.stringify({
                        "argument": {
                            "authUuid": "",
                            "cameraIndexCode": cameraIdx,
                            "ezvizDirect": 0,
                            "gpuMode": 0,
                            "streamMode": 0,
                            "transMode": 1,
                            "wndId": i+1,
                        "cascade": 1
                        },
                        "funcName": "startPreview"
                    });
                    that.requestInterface(previewParam);
                }
            });
        },
        */
    // 批量播放轮巡函数
    MultiTourPreview(cameraIndexArray) {

      // // 解析轮巡的监控点编号
      // var param = $("#TourPreviewCamIdx").val();
      // //param = param.replace(/(\s*)/g, "");
      // var cameraIndexArray = new Array();
      // cameraIndexArray = param.split(",");
      var arraySize = cameraIndexArray.length;

      let that = this
      // 获取当前窗口个数
      var WndNum = 1;
      this.oWebControl.JS_RequestInterface({
        funcName: "getLayout"
      }).then(function (oData) {
        //分析窗口数
        var Data = JSON.stringify(oData.responseMsg.data);
        Data = Data.replace(/\\n/g, "");
        Data = Data.replace(/\\/g, "");
        Data = Data.replace(/\"{/g, "{");
        Data = Data.replace(/}\"/g, "}");
        WndNum = JSON.parse(Data).wndNum;

        var multiPlayParam = {
          "argument": {
            "list": []
          },
          "funcName": "startMultiPreviewByCameraIndexCode"
        }

        for (let i = 0; i < arraySize; i++) {
          var PlayParam = {
            "authUuid": "",
            "cameraIndexCode": cameraIndexArray[i],
            "ezvizDirect": 0,
            "gpuMode": 0,
            "streamMode": 0,
            "transMode": 1,
            "wndId": i + 1
          }

          multiPlayParam.argument.list.push(PlayParam);
        }
        // console.log('MultiTourPreview',multiPlayParam)
        var previewParam = JSON.stringify(multiPlayParam);
        // console.log('MultiTourPreview',previewParam)
        that.requestInterface(previewParam);
      });

    },
    // value为字符串，JS_RequestInterface仅接收json格式的变量，且需要先解析出argument，并且将argument字段的内容转为字符串
    requestInterface(value) {
      // console.log('-------requestInterface----------')
      this.isJSON(value);
      var JsonParam = JSON.parse(value);
      var JsonArgument = JsonParam.argument;
      JsonParam.argument = JSON.stringify(JsonArgument);
      let that = this
      this.oWebControl.JS_RequestInterface(JsonParam).then(function (oData) {
        // console.log(oData)
        that.showCBInfo(JSON.stringify(oData ? oData.responseMsg : ''));
      });
    },
    // 判断字符串是否为json
    isJSON(str) {
      // console.log('isJSON')
      if (typeof str == 'string') {
        try {
          var obj = JSON.parse(str);
          if (typeof obj == 'object' && obj) {
            return true;
          } else {
            this.showCBInfo("param is not the correct JSON message");
            return false;
          }
        } catch (e) {
          this.showCBInfo("param is not the correct JSON message");
          return false;
        }
      }
      // console.log('It is not a string!')
    },
    // 显示接口返回的消息及插件回调信息
    showCBInfo(szInfo, type) {
      if (type === 'error') {
        szInfo = "<div style='color: red;'>" + this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss") + " " + szInfo + "</div>";
      } else {
        szInfo = "<div>" + this.dateFormat(new Date(), "yyyy-MM-dd hh:mm:ss") + " " + szInfo + "</div>";
      }
      // $("#cbInfo").html(szInfo + $("#cbInfo").html());
    },
    // 格式化时间
    dateFormat(oDate, fmt) {
      var o = {
        "M+": oDate.getMonth() + 1, //月份
        "d+": oDate.getDate(), //日
        "h+": oDate.getHours(), //小时
        "m+": oDate.getMinutes(), //分
        "s+": oDate.getSeconds(), //秒
        "q+": Math.floor((oDate.getMonth() + 3) / 3), //季度
        "S": oDate.getMilliseconds()//毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (oDate.getFullYear() + "").substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        }
      }
      return fmt;
    },
    // 获取公钥
    getPubKey(callback) {
      let that = this;
      this.oWebControl
        .JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({
            keyLength: 1024,
          }),
        })
        .then(function (oData) {
          if (oData.responseMsg.data) {
            that.pubKey = oData.responseMsg.data;
            callback();
          }
        });
    },
    // RSA 加密
    setEncrypt(value) {
      let that = this;
      let encrypt = new window.JSEncrypt();
      encrypt.setPublicKey(that.pubKey);
      this.EncryptKey = encrypt.encrypt(value)
      // console.log('setEncrypt',this.EncryptKey)
      return encrypt.encrypt(value);
    },
    // 回调的消息
    cbIntegrationCallBack(oData) {
      let { responseMsg: type } = oData;
      if (type === "error") {
        // console.log('errors')
      }
    },
    /**
     * 监听浏览器窗口变化，以及关闭标签页变，并对插件做出处理
     */
    monitoringWindow() {
      let that = this
      // 标签关闭
      $(window).unload(function () {
        if (that.oWebControl != null) {
          that.oWebControl.JS_HideWnd(); // 先让窗口隐藏，规避插件窗口滞后于浏览器消失问题
          that.oWebControl.JS_Disconnect().then(
            function () { },
            function () { }
          );
        }
      });
      window.onresize = (e) => {
        return (() => {
          // console.log('monitoringWindow...',e)
          if (that.oWebControl != null) {
            //   // 首次加载时的到父容器的高度
            //   that.playWndHeight = that.$refs.playWnd.offsetHeight
            //   // // 首次加载时的到父容器的宽度
            //   that.playWndWidth = that.$refs.playWnd.offsetWidth
            // console.log('monitoringWindow...', $("#videoMain").width(),$("#videoMain").height())
            //   console.log('monitoringWindow...', $("#playWnd").width(),$("#playWnd").height())
            that.oWebControl.JS_Resize(

              $("#playWnd").width(),
              $("#playWnd").height()
            );
          }
        })();
      };
    },
  }
}
</script>
<style>
.playWnd {
  /* border: 1px solid red; */
  width: 86%;
  height: 84%;
  /* position: relative; */
}

.videoMain {
  /* z-index: 100; */
  width: 100%;
  height: 100%;
  /* margin-left: 100px; */
  /* background-color: white; */
}
</style>